import { useNavigation } from '@react-navigation/core'
import { useSelector } from 'react-redux'
import { Image, Text, TouchableOpacity, View } from 'react-native'
import styles from '../main.styles'
import { CustomTextInput } from '../../sign_up/SignupScreen.main'
import { i18n } from '$localization/config.js'
import ForgotPasswordButton from './ForgotPasswordButton'

const LOGIN_SCREEN_INPUT = 'login_screen_input'

function LoginForm({
  email,
  setEmail,
  showPassword,
  password,
  setPassword,
  setShowPassword,
}) {
  const navigation = useNavigation()
  const colorSettings = useSelector((state) => state.store.colorSettings)

  const parentRefs = {
    emailInputRef: null,
    passwordInputRef: null,
  }

  const setParentRef = (key, ref) => {
    if (!key || !ref) return
    parentRefs[key] = ref
  }

  const shouldShowPassword = showPassword
    ? require('$assets/images/icon/eye-close/black.png')
    : require('$assets/images/icon/eye/black.png')

  return (
    <View style={styles.loginAccountContainer}>
      <View style={styles.loginAccountHeaderContainer}>
        <Text style={styles.loginAccountHeaderText}>
          {i18n.t('already_have_an_account_login_instead')?.default}
        </Text>
      </View>
      <CustomTextInput
        setRef={(ref) => setParentRef('emailInputRef', ref)}
        nativeID={LOGIN_SCREEN_INPUT}
        colorSettings={colorSettings}
        label={i18n.t('email')?.default}
        keyboardType="email-address"
        onSubmitEditing={() => parentRefs.passwordInputRef.focus()}
        value={email}
        onChangeText={(value) => {
          setEmail(value)
        }}
      />
      <View style={styles.textInputPasswordContainer}>
        <CustomTextInput
          containerStyle={{ flex: 1 }}
          inputStyle={[
            styles.textInputField,
            styles.textInputPassword,
            {
              color: colorSettings?.text_input_color_1 ?? 'black',
            },
          ]}
          setRef={(ref) => setParentRef('passwordInputRef', ref)}
          nativeID={LOGIN_SCREEN_INPUT}
          colorSettings={colorSettings}
          label={i18n.t('password')?.default}
          secureTextEntry={showPassword}
          value={password}
          onChangeText={(value) => {
            setPassword(value)
          }}
        />
        <View
          style={[
            styles.showPasswordContainer,
            {
              borderBottomColor: colorSettings?.text_input_label_color_1,
            },
          ]}
        >
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={() => setShowPassword(!showPassword)}
          >
            <Image
              style={styles.showPasswordImage}
              source={shouldShowPassword}
            />
          </TouchableOpacity>
        </View>
      </View>
      <ForgotPasswordButton
        onPress={() => navigation.navigate('ForgotPWSelectOption')}
      />
    </View>
  )
}

export default LoginForm
